module.exports = __webpack_public_path__ + "nc_static/media/star.fb27c5e9.svg";